export const STANDARD_DATE_FORMAT = 'YYYY-MM-DD';
export const READABLE_DATE_FORMAT = STANDARD_DATE_FORMAT;
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_FULL_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const FILTER_DATE_FORMAT = STANDARD_DATE_FORMAT;
